import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';

interface ICountryType {
  name: string;
  dialCode: string;
  countryCode: string;
  format: string;
}

interface IPhoneNumberComponentProps {
  error?: string;
  value: string;
  countryCode: string;
  onChange: (data: { code: string; number: string; format: string }) => void;
  disabled?: boolean;
}

const PhoneInputComponent: React.FC<IPhoneNumberComponentProps> = ({
  error = '',
  value = '',
  countryCode = '',
  onChange = () => {},
  disabled = false,
}) => {
  const customStyles = {
    containerClass: `flex items-center border-1.5 rounded-1 border-grey outline-none disabled:bg-grey1 w-full  ${
      error ? 'border-red-500' : ''
    } h-12`,
    inputClass: `flex items-center px-4 py-2 border-1.5 rounded-1 border-grey focus:shadow-none outline-none disabled:bg-grey1 w-full  ${
      error ? 'border-red-500' : ''
    } h-12`,
    buttonClass: 'bg-gray text-white p-2 rounded-md focus:outline-none focus:shadow-none',
    dropdownClass: 'bg-white w-auto',
  };

  const inputStyle = {
    border: 'none',
    width: '100%',
    height: '100%',
    fontFamily: 'inter',
    fontWeight: 500,
    fontSize: '16px',
    color: '#64748B',
  };
  const handlePhoneNumberChange = (val: string, data: ICountryType) => {
    const dialCode = data.dialCode || '';
    const mobile_no = val.replace(dialCode, '').trim();
    onChange({ code: dialCode, number: mobile_no || '', format: data?.format || '' });
  };
  return (
    <div
      className={`flex flex-col space-y-1 w-full relative border-0 ${
        disabled ? 'pointer-events-none' : ''
      }`}
    >
      <PhoneInput
        country={'es'}
        enableSearch={false}
        value={`${countryCode}${value}` || ''}
        onChange={(val, data: ICountryType) => handlePhoneNumberChange(val, data)}
        inputClass={customStyles.inputClass}
        buttonClass={customStyles.buttonClass}
        containerClass={customStyles.containerClass}
        dropdownClass={customStyles.dropdownClass}
        inputStyle={{
          ...inputStyle,
        }}
        dropdownStyle={{ color: '#64748B', fontFamily: 'inter', fontWeight: 500 }}
      />
      {error && <p className=" font-regular text-xs text-red-500 text-left">{error}</p>}
    </div>
  );
};

export default PhoneInputComponent;
